import './wakefieldmillfrench/style';
import FormStructure from './wakefieldmillfrench/form_structure';

export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js